
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M19.937 20.501a.557.557 0 01-.4-.165l-4.572-4.573a6.95 6.95 0 11.8-.8l4.572 4.58a.563.563 0 01-.4.963zM10.46 4.628a5.828 5.828 0 104.1 9.977.138.138 0 01.023-.025.278.278 0 01.036-.032 5.834 5.834 0 00-4.157-9.92z","data-name":"Pfad 14160","fill":"#1b5be9","stroke":"#1b5be9","stroke-width":".25"}})])
          )
        }
      }
    